export const Loader = {
    template: `
    <div class="load">
        <div class="xLoader form-preload">
            <div class="audio-wave">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>
`
}
